import { render, staticRenderFns } from "./PointsFields.vue?vue&type=template&id=31d0ab3f&"
import script from "./PointsFields.vue?vue&type=script&lang=js&"
export * from "./PointsFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports